var loki = (typeof require != "undefined") ? require('lokijs') : false;
const lfsa = (typeof require != "undefined") ? require('lokijs/src/loki-fs-structured-adapter.js') : false;

(function ($, Promise) {

		// Setup the prototype inheritance
		extend(BaseGame, Quiz);

		// Constructor
		function Quiz(id) {

			// Super constructor
			BaseGame.call(this);

			// Reset timer delay
			this.resetDelay = 60 * 1000;
			// this.resetDelay = -1;

			// Save game id
			this.id = id;

			// Screensaver animation
			this.screenSaverAnimationTimeout = false;
			this.sceenSaverAnimationTimeline = false;
			// this.screenSaverAnimationDelay = 120 * 1000;
			this.screenSaverAnimationDelay = -1;

			// Override toolbar screen
			this.activateToolbarFrom = 1;
			// this.activateToolbarFrom = 0;

			// Backgrounds animations handling
			this.currentBackground = 0;
			this.backgroundInterval = false;

			// Stagger animation timeline
			this.animateInTimeline = false;

			// Hold is animating variable
			this.animating = false;

			// Side image vivus
			this.sideImageVivus = [];

			// Pie chart canvas
			this.quizCtx = document.getElementById("pie-chart").getContext('2d');
			this.pieChart = false;

			// Variable to hold data
			this.data = {}

			// User values
			this.currentQuestion = 0;
			this.currentScoreValueSeleted = false;
			this.userScores = {};

			// Load data then init
			this.loadData();

			// Database
			this.db = false;
			this.dbEntries = false;
			if (loki !== false) {
				this.adapter = new lfsa();

				// email database, trying to be send every 15 seconds
				this.db = new loki('quiz_results.db', {
					adapter: this.adapter,
					autoload: true,
					autoloadCallback: $.proxy(this.initEntriesDatabase, this),
					autosave: true,
					autosaveInterval: 4000
				});
			}
		}

		// Init database of results
		Quiz.prototype.initEntriesDatabase = function () {
			this.dbEntries = this.db.getCollection("entries");
			if (this.dbEntries === null) {
				this.dbEntries = this.db.addCollection("entries");
			}
		};

		Quiz.prototype.loadData = function () {

			// Load JSON for ZONES
			var json1 = $.ajax({
				url: "data/quiz-" + this.id + ".json",
				dataType: 'json',
				cache: false,
				complete: $.proxy(function (data) {
					this.data = JSON.parse(data.responseText);
				}, this)
			});

			// Wait for all
			Promise.all([
				json1.promise(),
				// json2.promise(),
				// json3.promise(),
			]).then($.proxy(function () {
				this.initGame();
			}, this));

		};


		Quiz.prototype.initGame = function () {

			// console.log(this.data)

			$("#main-title .fr").html(this.data["screen1"]["title_fr"]);
			$("#main-title .en").html(this.data["screen1"]["title_en"]);
			$("#screen-1 .description .fr").html(this.data["screen1"]["description_fr"]);
			$("#screen-1 .description .en").html(this.data["screen1"]["description_en"]);

			$("#screen-2 .title .fr").html(this.data["screen2"]["title_fr"]);
			$("#screen-2 .title .en").html(this.data["screen2"]["title_en"]);
			$("#screen-2 .description .fr").html(this.data["screen2"]["description_fr"]);
			$("#screen-2 .description .en").html(this.data["screen2"]["description_en"]);

			$(this.data.questions).each($.proxy(function (i, n) {

				// Clone
				var $el = $("#questions-list-model").clone();
				$el.attr("id", "question-" + (i + 1));

				// Set texts
				$el.find(".question-context .fr").html(n.context_fr);
				$el.find(".question-context .en").html(n.context_en);
				$el.find(".question-label .fr").html(n.label_fr);
				$el.find(".question-label .en").html(n.label_en);
				$el.find(".question-description .fr").html(n.description_fr);
				$el.find(".question-description .en").html(n.description_en);

				// Set side image
				$el.find(".side-image .svg").attr("src", n.side_image).attr("id", "side-image-" + (i + 1));

				// Set choices
				$(n.choices).each($.proxy(function (i2, n2) {

					var $choiceEl = $el.find("#question-choice-model").clone();
					$choiceEl.attr("id", "question-" + (i + 1) + "-choice-" + (i2 + 1));

					$choiceEl.find(".choice-title .fr").html(n2.title_fr);
					$choiceEl.find(".choice-title .en").html(n2.title_en);

					$choiceEl.find(".choice-description .fr").html(n2.description_fr);
					$choiceEl.find(".choice-description .en").html(n2.description_en);

					$choiceEl.attr("data-score-value", n2.value)
					$choiceEl.attr("data-action-arg", n2.value)

					$el.find(".question-choices").append($choiceEl);

				}, this));

				// Remove choice model
				$el.find("#question-choice-model").remove();

				// Breadcrumbs
				var $breadcrumbEl = $("#questions-breadcrumbs-part-model").clone();
				$breadcrumbEl.attr("id", "questions-breadcrumb-" + (i + 1));
				$breadcrumbEl.find(".fr").html("Question " + (i + 1) + " / " + this.data.questions.length);
				$breadcrumbEl.find(".en").html("Question " + (i + 1) + " / " + this.data.questions.length);
				$("#questions-breadcrumbs").append($breadcrumbEl);

				// Append to DOM
				$("ul.questions-list").append($el);

			}, this));

			$(this.data.results).each($.proxy(function (i, n) {
				console.log(n)
				$("#screen-4 .chart-legend-item").eq(i).find(".fr").html(n["short_title_fr"]);
				$("#screen-4 .chart-legend-item").eq(i).find(".en").html(n["short_title_en"]);
			}), this);

			// Remove item model
			$("#questions-list-model").remove();
			$("#questions-breadcrumbs-part-model").remove();

			// Load SVGs
			convertSVGToInline($.proxy(function () {
				this.initVivus();
			}, this));

			// Init pie chart
			this.pieChart = new Chart(this.quizCtx, {
				type: 'doughnut',
				// type: 'cutOutPie',
				options: {
					cutoutPercentage: 0,
					segmentShowStroke: false,
					legend: {
						display: false,
					},
					tooltips: {
						enabled: false,
					},
				}
			});

			// Background interval
			this.backgroundInterval = setInterval($.proxy(function () {
				if (this.currentScreen == 1) {
					this.gotoNextBackground()
				}
			}, this), 10000);

			// Go to first element
			this.goToScreen(1);
			// this.goToScreen(2);
			// this.goToScreen(3);
			// setTimeout($.proxy(function () {
			// 	this.goToScreen(4);
			// }, this), 400)
		};


		Quiz.prototype.initVivus = function (screenId, callback) {

			// Front vivus
			var lastplay = 1;
			var vivussvg = new Vivus('front-svg', {
				// type: 'oneByOne',
				start: 'autostart',
				duration: 900,
				delay: 500,
				animTimingFunction: Vivus.EASE_OUT
			}, function () {
				// Toggle back and forth animation
				lastplay *= -1;
				setTimeout(function () {
					vivussvg.play(lastplay);
				}, (lastplay == -1) * 5000)
			});

			// Side-image vivus
			$(".side-image svg").each($.proxy(function (i, n) {
				this.sideImageVivus.push(new Vivus($(n).attr("id"), {
					start: 'manual',
					duration: 650,
					delay: 100,
					animTimingFunction: Vivus.EASE_OUT
				}));
			}, this));


		}

		// Background handler
		Quiz.prototype.gotoNextBackground = function () {

			this.currentBackground = (this.currentBackground + 1) % $("#backgrounds .background").length;

			$("#backgrounds .background.active").addClass("out previous");
			$("#backgrounds .background").eq(this.currentBackground).addClass("active");

			$("#backgrounds .background").eq(this.currentBackground).one(window.transitionEnd, $.proxy(function () {
				$("#backgrounds .background.previous").removeClass("active");
				$("#backgrounds .background").eq(this.currentBackground).addClass("active").removeClass("out");

				$("#backgrounds .background.previous").one(window.transitionEnd, $.proxy(function () {
					$("#backgrounds .background.previous").removeClass("previous");
				}, this));

			}, this));

		}

		// Background animation handler
		Quiz.prototype.toggleBackgroundAnimations = function (on) {
			$("#front-svg-wrapper").fadeTo(400, on == true)
		}

		Quiz.prototype.goToScreen = function (screenId, callback) {

			// Super constructor
			BaseGame.prototype.goToScreen.call(this, screenId, callback)

			// Stop animate in
			if (this.animateInTimeline) {
				this.animateInTimeline.progress(1).kill();
				this.animateInTimeline = false;
			}

			if (screenId == 1) {
				this.toggleBackgroundAnimations(true);
				this.requestSceenSaverAnimatonTimer(this.screenSaverAnimationDelay);
			} else if (screenId == 2) {
				this.toggleBackgroundAnimations(true);
				this.requestSceenSaverAnimatonTimer(0, true);
			} else if (screenId == 3) {
				this.toggleBackgroundAnimations(false);
				this.goToNextQuestion(0)
			} else if (screenId == 4) {
				this.toggleBackgroundAnimations(false);
				this.buildScoreScreen();
			}

			// Animate in
			this.animateInTimeline = new TimelineMax();
			$("#screen-" + screenId).find("div.animate-in").each($.proxy(function (i, n) {
				this.animateInTimeline.from(n, 0.35, {
					y: "-=20",
					opacity: 0,
					ease: Sine.easeOut
				}, ((i == 0) ? 0.5 : "-=" + 0.05))
			}, this));

		}

		Quiz.prototype.goToHome = function () {
			this.reset(1)
		}

		Quiz.prototype.goToScrenSaver = function () {

			// Super constructor
			var shouldReset = BaseGame.prototype.shouldReset.call(this);

			if (shouldReset) {
				this.reset(1);
			}
		}

		Quiz.prototype.goToNextQuestion = function (specificQuestion) {

			// Reset selected value
			this.currentScoreValueSeleted = false;

			// Set as animating
			this.animating = true;

			// Select next question
			if (typeof specificQuestion != "undefined") {
				this.currentQuestion = specificQuestion;
			} else {
				this.currentQuestion = (this.currentQuestion + 1) % app.data.questions.length;
				if (this.currentQuestion == 0) {
					this.goToNextScreen();
					return;
				}
			}

			// Hide current question
			if ($(".questions-list-item.current").length > 0) {
				$(".questions-list-item.current").fadeOut(400, $.proxy(function () {
					this.animating = false;
					$(".questions-list-item.current").removeClass("current");
					$(".questions-list-item").eq(this.currentQuestion).hide().fadeIn(400).addClass("current");
				}, this));
			} else {
				this.animating = false;
				$(".questions-list-item").hide().eq(this.currentQuestion).show().addClass("current");
			}

			// Replay side image (vivus)
			this.sideImageVivus[this.currentQuestion].reset().play();

			// Handle breadcrumbs
			$(".questions-breadcrumbs-part.current").addClass("completed");
			$(".questions-breadcrumbs-part").removeClass("current");
			$("#questions-breadcrumb-" + (this.currentQuestion + 1)).addClass("current");
		}

		Quiz.prototype.selectChoice = function (choiceValue) {

			if (this.animating) {
				return;
			}
			console.log("selectChoice", this.animating)

			// Styling
			$(".questions-list-item.current .question-choice").removeClass("selected")
			$(".questions-list-item.current .question-choice[data-score-value='" + choiceValue + "']").addClass("selected")

			// Save selected value
			this.currentScoreValueSeleted = choiceValue;
		}

		Quiz.prototype.confirmChoice = function () {

			// Set user score entry if not already set
			if (typeof this.userScores[this.currentScoreValueSeleted] == "undefined") {
				this.userScores[this.currentScoreValueSeleted] = 0;
			}

			// Increase score value
			this.userScores[this.currentScoreValueSeleted] = parseInt(this.userScores[this.currentScoreValueSeleted]) + 1;

			// Remove selected class
			$(".questions-list-item .question-choice").removeClass("selected")

			// Go to next question
			this.goToNextQuestion();
		}

		Quiz.prototype.buildScoreScreen = function () {

			// Get user result
			var sortedResults = Object.keys(this.userScores).sort($.proxy(function (a, b) {
				return this.userScores[b] - this.userScores[a]
			}, this));
			var result = sortedResults[0];

			// console.log(sortedResults)
			console.log("User is " + result)

			// Increase database result
			this.increaseResult(result);

			// Get all database results and use array sort to put selecte entry in first
			var entriesData = this.getResults();
			entriesData.sort(function (a, b) {
				return a.name != result;
			});

			// Set choices
			$(this.data.results).each($.proxy(function (i, n) {
				if (n.name == result) {

					$("#screen-4 .title .fr").html(n.title_fr);
					$("#screen-4 .title .en").html(n.title_en);

					$("#screen-4 .description .fr").html(n.description_fr);
					$("#screen-4 .description .en").html(n.description_en);

					$("#screen-4 .fr .short-title").html(n.short_title_fr);
					$("#screen-4 .en .short-title").html(n.short_title_en);

					$("#screen-4 .finale .fr ").html(this.data.finale_fr.replace(/\{\{short_title\}\}/g, n.short_title_fr));
					$("#screen-4 .finale .en ").html(this.data.finale_en.replace(/\{\{short_title\}\}/g, n.short_title_en));

					// $("#screen-4 .finale").html($("#screen-4 .finale").html().replace(/\{\{short_title\}\}/g, n.short_title_en));
					$("#screen-4 .finale").html($("#screen-4 .finale").html().replace(/\{\{percent\}\}/g, entriesData[0].percent));

					$("#screen-4 .icon").css({
						"background": "transparent url('" + n.icon + "') no-repeat center center",
						"background-size": "contain",
					});

					this.buildPieChat(entriesData);
				}


				// Set custom legend colors
				$("#game-quiz #screen-4 .chart-legend ul.chart-legend-items li.chart-legend-item:eq(" + i + ") .square").css({
					"background-color": this.getCSSRGBAForRGB(this.data.results[i].color)
				});

			}, this));

		}


		Quiz.prototype.buildPieChat = function (entriesData) {

			// Comput total of votes and create values simple array
			var total = 0;
			var values = []
			for (var i = 0; i < entriesData.length; i++) {
				total += parseInt(entriesData[i].count);
				values.push(entriesData[i].count)
			}

			// Update entriesData
			this.pieChart.data = {
				labels: ["1", "2", "3"],
				datasets: [{
					label: '# of Votes',
					data: values,
					backgroundColor: [
						this.getCSSRGBAForRGB(this.data.results[0].color),
						this.getCSSRGBAForRGB(this.data.results[1].color),
						this.getCSSRGBAForRGB(this.data.results[2].color),
					],
					hoverBackgroundColor: [
						this.getCSSRGBAForRGB(this.data.results[0].color),
						this.getCSSRGBAForRGB(this.data.results[1].color),
						this.getCSSRGBAForRGB(this.data.results[2].color),
					],
					borderWidth: 0,
				}]
			};

			console.log("Stats are ", entriesData[0], "Total of " + total)

			// Set rotation
			this.pieChart.options.rotation = Math.PI - (((parseInt(entriesData[0].count) / total) / 2) * (Math.PI * 2));
			this.pieChart.update();
		}

		Quiz.prototype.getResults = function () {

			var output = [];

			// Get results from db
			if (this.db !== false) {
				var entriesData = this.dbEntries.find();
				if (entriesData != null) {
					for (var i = 0; i < entriesData.length; i++) {
						output.push({
							name: entriesData[i].name,
							count: entriesData[i].count
						})
					}
				}
			}

			// Complete with empty results
			for (var i = 0; i < this.data.results.length; i++) {

				// Define if already created
				var alreadyCreated = false;
				for (var i2 = 0; i2 < output.length; i2++) {
					if (output[i2].name == this.data.results[i].name) {
						alreadyCreated = true;
						break;
					}
				}

				if (!alreadyCreated) {
					output.push({
						name: this.data.results[i].name,
						count: 1
					})
				}
			}

			// Compute total
			var total = 0;
			for (var i = 0; i < output.length; i++) {
				total += output[i].count;
			}

			// Compute percents
			for (var i = 0; i < output.length; i++) {
				output[i].percent = Math.round(output[i].count / total * 100);
				if (isNaN(output[i].percent)) {
					output[i].percent = 0;
				}
			}

			// Return ouput
			return output;
		}

		Quiz.prototype.increaseResult = function (result) {

			if (this.db !== false) {

				var entryData = this.dbEntries.findOne({'name': result});

				if (entryData != null) {

					// Update
					entryData.count += 1;
					this.dbEntries.update(entryData);

				} else {

					// Create
					var entryData = {
						name: result,
						count: 2,
					};

					this.dbEntries.insert(entryData);
				}

			}
		};

		Quiz.prototype.requestSceenSaverAnimatonTimer = function (delay, clearOnly) {

			// Stop current timeout
			if (this.screenSaverAnimationTimeout !== false) {
				clearRequestInterval(this.screenSaverAnimationTimeout);
				this.screenSaverAnimationTimeout = false;
			}

			if (this.sceenSaverAnimationTimeline !== false) {
				this.sceenSaverAnimationTimeline.progress(1).kill();
				this.sceenSaverAnimationTimeline = false;
			}

			// Stop here if we wanted a clear only
			if (typeof clearOnly != "undefined" && clearOnly == true) {
				return;
			}

			// Request timeout
			if (this.screenSaverAnimationDelay > -1) {
				this.screenSaverAnimationTimeout = requestInterval($.proxy(this.sceenSaverAnimation, this), delay);
			}
		}

		Quiz.prototype.sceenSaverAnimation = function () {

			// Handle animation
			this.sceenSaverAnimationTimeline = new TimelineMax();
			this.sceenSaverAnimationTimeline.to("#screen-1 .language-button.fr", 0.5, {
				y: "-=100",
				opacity: 0,
				ease: Sine.easeInOut
			}, "-=0.2");
			this.sceenSaverAnimationTimeline.to("#screen-1 .language-button.en", 0.5, {
				y: "-=100",
				opacity: 0,
				ease: Sine.easeInOut
			}, "-=0.2");
			this.sceenSaverAnimationTimeline.to("#screen-1 .description", 0.5, {
				y: "-=100",
				opacity: 0,
				ease: Sine.easeInOut
			}, "-=0.2");
			this.sceenSaverAnimationTimeline.to("#screen-1 #main-title", 0.5, {
				y: "-=100",
				opacity: 0,
				ease: Sine.easeInOut
			}, "-=0.2");
			this.sceenSaverAnimationTimeline.to("#backgrounds", 0.5, {
				opacity: 0,
				ease: Sine.easeInOut
			}, "-=0.2");
			this.sceenSaverAnimationTimeline.to("#backgrounds", 0.5, {
				opacity: 1,
				ease: Sine.easeInOut
			}, "+=0.7");
			this.sceenSaverAnimationTimeline.to("#screen-1 #main-title", 0.5, {
				y: "+=100",
				opacity: 1,
				ease: Sine.easeInOut
			}, "-=0.2");
			this.sceenSaverAnimationTimeline.to("#screen-1 .description", 0.5, {
				y: "+=100",
				opacity: 1,
				ease: Sine.easeInOut
			}, "-=0.2");
			this.sceenSaverAnimationTimeline.to("#screen-1 .language-button.fr", 0.5, {
				y: "+=100",
				opacity: 1,
				ease: Sine.easeInOut
			}, "-=0.2");
			this.sceenSaverAnimationTimeline.to("#screen-1 .language-button.en", 0.5, {
				y: "+=100",
				opacity: 1,
				ease: Sine.easeInOut
			}, "-=0.2");
		}

		Quiz.prototype.getCSSRGBAForRGB = function (color) {
			return 'rgba(' + color.r + ', ' + color.g + ', ' + color.b + ', 1)';
		}

		Quiz.prototype.reset = function (destinationScreen) {

			this.animating = false;
			this.currentQuestion = 0;
			this.currentScoreValueSeleted = false;
			this.userScores = {};

			// Handle CSS classses
			$(".question-choice").removeClass("selected")
			$(".questions-breadcrumbs-part").removeClass("completed current");

			// Define destination screen
			destinationScreen = destinationScreen || 1;

			// Go to screen
			this.goToScreen(destinationScreen);
		}


		// Expose Timeline
		window.Quiz = Quiz;

	}
)(jQuery, Promise);